var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from '../core/base';
var Slider = (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Slider.prototype.run = function () {
        this.play();
    };
    Slider.prototype.play = function () {
        this._j('#featured-posts').slick({
            autoplay: true,
            autoplaySpeed: 10000,
            dots: true,
            infinite: true,
            nextArrow: this.nextArrow(),
            prevArrow: this.prevArrow(),
            speed: 500,
        });
    };
    Slider.prototype.prevArrow = function () {
        return "<button type=\"button\" class=\"slick-prev\">\n            <span class=\"fas fa-angle-left\"></span>\n            <span class=\"icon-text\">".concat(alumniSliderL10n.prev, "</span>\n        </button>");
    };
    Slider.prototype.nextArrow = function () {
        return "<button type=\"button\" class=\"slick-next\">\n            <span class=\"icon-text\">".concat(alumniSliderL10n.next, "</span>\n            <span class=\"fas fa-angle-right\"></span>\n        </button>");
    };
    return Slider;
}(Base));
export { Slider };
